import type { Item } from '../schemas/equipment';

/**
 * Peso totale di uno stack di item identici nell'inventario.
 *
 * `Item.weight` è UNITARIO (peso del singolo pezzo). Per ottenere il peso
 * complessivo di un'entry dell'inventario con `quantity > 1`, moltiplicare
 * per la quantità. Se `quantity` è assente (campo opzionale), equivale a 1.
 *
 * Esempio:
 *  - 3 Pugnali da lancio (`weight: 0, quantity: 3`) → peso totale 0
 *  - 22 monete (`weight: 0, quantity: 22`) → peso totale 0
 *  - Maglia di ferro (`weight: 1`, quantity assente) → peso totale 1
 *
 * Helper introdotto come parte della risoluzione di FI-16. Sostituisce
 * il pattern del workaround precedente, dove la quantità viveva nel
 * `name` dell'item (es. `name: '10 monete'`) e il peso totale non era
 * derivabile programmaticamente.
 */
export function getItemTotalWeight(item: Item): number {
  return item.weight * (item.quantity ?? 1);
}
